import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/bff/client';

import { getCurrencySymbol } from '@utils/CurrencyFormatter';
import debounce from '@utils/debounce';

const MIN_VALUE = 0;
const MIN_PRICE = 'minPrice';
const MAX_PRICE = 'maxPrice';
const DEBOUNCE_TIMEOUT = 750;

const priceCorrelation = {
  [MIN_PRICE]: {
    key: MAX_PRICE,
    mustChange: (value, target) => value > parseInt(target, 10)
  },
  [MAX_PRICE]: {
    key: MIN_PRICE,
    mustChange: (value, target) => value < parseInt(target, 10)
  }
};

const PriceInput = props => (
  <div className={`add-edit-form__price-wrapper ${props.className}`}>
    <input
      className="add-edit-form__price-input"
      type="number"
      onChange={props.onChange}
      value={props.value}
      min={MIN_VALUE}
      placeholder={props.placeholder}
    />
    <div className="add-edit-form__currency">{props.currency}</div>
  </div>
);

class AlertPriceRange extends PureComponent {
  static propTypes = {
    minPrice: PropTypes.string.isRequired,
    maxPrice: PropTypes.string.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    hasError: PropTypes.bool.isRequired
  };

  setMinPrice = e => {
    this.updatePrices(MIN_PRICE, parseInt(e.target.value, 10));
  };

  setMaxPrice = e => {
    this.updatePrices(MAX_PRICE, parseInt(e.target.value, 10));
  };

  updatePrices = (key, value) => {
    this.props.onChange({ [key]: value });
  };

  checkValidPrices = debounce(currentKey => {
    const { key: targetKey, mustChange } = priceCorrelation[currentKey];
    const currentValue = this.props[currentKey];
    const targetValue = this.props[targetKey];

    if (currentValue && targetValue && mustChange(currentValue, targetValue)) {
      this.props.onChange({
        [targetKey]: currentValue
      });
    }
  }, DEBOUNCE_TIMEOUT);

  render() {
    const { hasError, minPrice, maxPrice } = this.props;
    const currency = getCurrencySymbol(this.props.currencyIsoCode);
    const errorClassName = hasError
      ? 'add-edit-form__price-wrapper--error'
      : '';

    return (
      <Fragment>
        <div className="add-edit-form__grid-label">
          {trans('alerts.modal.prices')}
        </div>
        <div>
          <div>
            <PriceInput
              onChange={this.setMinPrice}
              value={minPrice}
              placeholder={trans('alerts.modal.prices.from')}
              currency={currency}
              className={errorClassName}
            />
            <PriceInput
              onChange={this.setMaxPrice}
              value={maxPrice}
              placeholder={trans('alerts.modal.prices.to')}
              currency={currency}
              className={errorClassName}
            />
          </div>
          {hasError && (
            <div className="add-edit-form__error-message">
              {trans('alerts.modal.prices.error')}
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default AlertPriceRange;
